import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDiscountProducts } from "./discountProductsApi";

//Async thunk
export const fetchDiscountProductsThunk = createAsyncThunk(
    "payments/fetchDiscountProducts",
    async (payload, { rejectWithValue, signal }) => {
        try {
            const res = await fetchDiscountProducts(payload, signal);
            return res;
        } catch (error) {
            return rejectWithValue(error.message || "Failed to fetch products");
        }
    }
);